import Iconify from "minimals-template/components/Iconify"
import { Secure } from "lib/authorization/secure"
import { Redirect } from "lib/@components/redirect"
import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { authoringRoute } from "../authoring.runtime"
import { AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { FEATURE_FLAG_SCHEDULE_COMMENTARY } from "authoring/lib/enum/authoring-feature-flags.mjs"
import { ScheduleCommentaryPublishingPage } from "./schedule-commentary-publishing-page"

const SCHEDULE_COMMENTARY_DEMANDS = [
    "user",
    `$feature-${FEATURE_FLAG_SCHEDULE_COMMENTARY}`,
    AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND,
]

authoringRoute.register(
    "publish-commentary",
    <Secure demand={SCHEDULE_COMMENTARY_DEMANDS} and fallback={<Redirect to="/authoring/" />}>
        <ScheduleCommentaryPublishingPage $lazy />
    </Secure>
)

registerConditionalPageNavigation(
    () =>
        isEnabled(FEATURE_FLAG_SCHEDULE_COMMENTARY) &&
        hasDemand("user") &&
        hasDemand(AUTHORING_GENERATE_SCHEDULE_COMMENTARY_DEMAND),
    "/authoring/publish-commentary",
    "Schedule Commentary",
    <Iconify icon="mdi:comment-text-multiple-outline" />,
    { group: "Updates Documentation", priority: 155 }
)
